const logs = {
    page_title: 'บันทึกการตรวจสอบ',
    title: 'บันทึกการตรวจสอบ',
    subtitle: 'ดูข้อมูลบันทึกเหตุการณ์การยืนยันตัวตนที่ผู้ใช้ของคุณดำเนินการ',
    event: 'เหตุการณ์',
    user: 'ผู้ใช้',
    application: 'แอปพลิเคชัน',
    time: 'เวลา',
    filter_by: 'กรองตาม',
    last_1_hour: '1 ชั่วโมงล่าสุด',
    last_24_hours: '24 ชั่วโมงล่าสุด',
    last_7_days: '7 วันล่าสุด',
    last_30_days: '30 วันล่าสุด',
    custom_range: 'กำหนดเอง',
    from: 'จาก',
    to: 'ถึง',
};
export default Object.freeze(logs);
